export const Functions = {
  create: false,
  delete: false,
  detail: false,
  search: true,
};

export const PageName = '管理员操作日志';
